import(/* webpackMode: "eager", webpackExports: ["ArrowIcon"] */ "/home/pi/prod/strawman/apps/web/components/ResourceDetails/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/pi/prod/strawman/node_modules/.pnpm/next@15.4.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/node_modules/.pnpm/next@15.4.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
